// role.js
import { decode } from "jsonwebtoken";

function decodeToken() {
    let token;
    if(sessionStorage.getItem("authToken")){
        token = sessionStorage.getItem("authToken");
    }else{
        token = localStorage.getItem("authToken");
    }
    if(!token){
        return undefined;
    }

    const fields = decode(token);
    return fields;
}

/**
 * @desc Decodes the auth token in local storage, and grabs the user role value.
 * @returns user role
 */
const getRole = () => {
    let tokenFields = decodeToken();

    if (!tokenFields) return;

    return tokenFields.role;
}

/**
 * @desc Decodes the auth token in local storage, and grabs the user email value.
 * @returns user email
 */
const getEmail = () => {
    let tokenFields = decodeToken();

    if (!tokenFields) return;
    
    return tokenFields.email;
}


/**
 * @desc Decodes a token and returns all fields.
 * @returns All fields
 */
const getFeatures = () => {
    const tokenFields = decodeToken();
    return Array.isArray(tokenFields?.features) ? tokenFields.features : [];
}
const getTokenFields = () => {
    let tokenFields = decodeToken();

    if (!tokenFields) return;
    
    return tokenFields;
}


export default {
    getRole,
    getEmail,
    getFeatures,
    getTokenFields
};